import { ProblemDetails } from "src/models/ProblemDetails";
import { defaultFetch, fetchWithAuth } from "../utils/auth";
import { MinAgeOverrideResponse } from "src/models/types";

export const verifyUserAndTicketAccessibilityMatch = async (ticketid: number): Promise<any> => {
  let response;
  let url = `/api/backend/tickets/user-accessibility/${ticketid}`
  let message = null;
  try {
      const res = await fetchWithAuth(url, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json'
          },
      });
      if (res.status >= 400 && res.status < 600) {
          const resText = await res.json();
          throw new Error(resText.errors.message);
      }

  } catch (error) {
      if (error instanceof Error) {
          message = error.message;
      } else {
          message = 'Unable to determine accessibility match';
      }
  }
  return { data: response, error: message }
};

export const acceptTicket = async (ticketid: number): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/accept/${ticketid}`;
    const res = await fetchWithAuth(fetchUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const response = await res.json();
    return {
      response: response.success,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to load ticket";
    }
    return { error: message };
  }
};

export const acceptAllocationTicketByIdOrToken = async (tokenOrbookingInterestId: string | number, acceptedRelatedBookingInterestIds: number[]): Promise<any> => {
  let response;
  let message = null;

  try {
    let res;

    if (typeof tokenOrbookingInterestId === 'string') {
      const fetchUrl = `/api/backend/tickets/accept/${tokenOrbookingInterestId}`;
      res = await defaultFetch(fetchUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(acceptedRelatedBookingInterestIds)
      });
    } else {
      const fetchUrl = `/api/backend/tickets/acceptAllocationTicketById/${tokenOrbookingInterestId}`;
      res = await fetchWithAuth(fetchUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(acceptedRelatedBookingInterestIds)
      });
    }

    if (res.status >= 400 && res.status < 600) {
      const resText = await res.json();
      throw new Error(resText.errors.message);
    }

    response = await res.json()
  } catch (error) {
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to load ticket";
    }
  }

  return { data: response, error: message }
};

export const declineTicket = async (ticketId: number): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/cancel/${ticketId}`;
    const res = await fetchWithAuth(fetchUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const responseObject = await res.json();
    return {
      response: responseObject,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to decline ticket";
    }
    return { error: message };
  }
};

export const declineTicketbyTokenOrId = async (tokenOrbookingInterestId: string | number): Promise<any> => {
  try {
    let res;

    if (typeof tokenOrbookingInterestId === 'string') {
      const fetchUrl = `/api/backend/tickets/cancel/${tokenOrbookingInterestId}`;
      res = await defaultFetch(fetchUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else {
      const fetchUrl = `/api/backend/tickets/cancelByBookingInterestId/${tokenOrbookingInterestId}`;
      res = await fetchWithAuth(fetchUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
    }

    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const responseObject = await res.json();
    return {
      response: responseObject,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to decline ticket";
    }
    return { error: message };
  }
};

export const acceptTicketbyToken = async (token: string): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/accept/${token}`;
    const res = await defaultFetch(fetchUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res.status >= 400 && res.status < 600) {
      const resJson = await res.json();
      throw new Error(resJson.errors.message);
    }
    const response = await res.json();
    return {
      response,
    };
  } catch (error) {
    return { error };
  }
};

export const downloadTicket = async (userEmail: string, ticketId: number): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/download?ticketId=${ticketId}&email=${userEmail}`;
    let res = await fetchWithAuth(fetchUrl, {
      method: "GET",
      headers: {
        responseType: "blob",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const url = URL.createObjectURL(await res.blob());
    const link = document.createElement("a");
    link.href = url;
    link.download = "ticket.pdf";
    link.click();

    const responseObject = await res.json();
    return {
      response: responseObject.success,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to download ticket";
    }
    return { error: message };
  }
};

export const downloadAllocationTicket = async (bookingInterestToken: any): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/download/${bookingInterestToken}`;
    let res = await defaultFetch(fetchUrl, {
      method: "GET",
      headers: {
        responseType: "blob",
      },
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const url = URL.createObjectURL(await res.blob());
    const link = document.createElement("a");
    link.href = url;
    link.download = "ticket.pdf";
    link.click();

    const responseObject = await res.json();
    return {
      response: responseObject.success,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to download ticket";
    }
    return { error: message };
  }
};

/**
 * What the admin decided about a pending accessibility request.
 *  - Release: approve and hand the ticket over now, jumping the queue
 *  - Queue:   approve the need but leave them queued for the engine to serve in turn
 *  - Decline: refuse
 */
export type AccessibilityDecision = "Release" | "Queue" | "Decline";

export const processAccessibilityRequests = async (
  bookingInterestId: number,
  isAccepted: boolean,
  decision?: AccessibilityDecision
): Promise<any> => {
  try {
    const fetchUrl = `/api/backend/tickets/process-accessibility-requests/${bookingInterestId}`;
    // isAccepted is still sent: the endpoint falls back to it when decision is absent, so
    // the two stay consistent rather than the server having to guess between them.
    const requestBody = JSON.stringify({ bookingInterestId, isAccepted, decision });
    const res = await fetchWithAuth(fetchUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });
    if (res.status >= 400 && res.status < 600) {
      const resText = await res.text();
      console.warn(resText);
      throw new Error("Server not returned a valid response");
    }
    const response = await res.json();
    return {
      response: response.success,
    };
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to process accessibility requests";
    }
    return { error: message };
  }
};

export const processMinAgeOverrideRequests = async (bookingInterestId: number, isAccepted: boolean): Promise<MinAgeOverrideResponse> => {
  try {
    const fetchUrl = `/api/backend/tickets/process-min-age-override-requests/${bookingInterestId}`;
    const requestBody = JSON.stringify({ bookingInterestId, isAccepted });
    const response = await fetchWithAuth(fetchUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (response.status === 400) {
      const problemDetails: ProblemDetails = await response.json();
      console.warn(problemDetails);
      return new MinAgeOverrideResponse({ error: problemDetails })
    }

    return new MinAgeOverrideResponse({ data: true });
  } catch (error) {
    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = "Unable to process min age override requests";
    }

    return new MinAgeOverrideResponse({ error: message });
  }
};
